import { render } from "./FormInvoiceFUS.vue?vue&type=template&id=3125f8e0&scoped=true"
import script from "./forminvoiceFUS.view.js?vue&type=script&lang=js&external"
export * from "./forminvoiceFUS.view.js?vue&type=script&lang=js&external"

import "./forminvoiceFUS.css?vue&type=style&index=0&id=3125f8e0&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3125f8e0"]])

export default __exports__